import React from "react"

const HtmlContentSection = ({ embedCode }) => {
  if (!embedCode) return null

  return <div dangerouslySetInnerHTML={{ __html: embedCode }} />
}

export default HtmlContentSection
